import PropTypes from 'prop-types';

import { Box, SvgIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

import ExpandableImageComponent from '../../Image/ExpandableImageComponent';

import { imgDocumentIcon, pdfDocumentIcon } from '../../../res/svg/icons';
import { ButtonLink } from '../../Button';

const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  padding: '0.5rem 1rem',
  borderRadius: '1rem',
}));

const ShowDocumentComponent = ({ document, showDocument, imgUrl }) => (
  <Box>
    <StyledContainer id={document.id}>
      <Box width="2.4rem" height="2.4rem" mr="1rem">
        <SvgIcon viewBox="0 0 32 32">
          {document.type.includes('image') ? imgDocumentIcon : pdfDocumentIcon}
        </SvgIcon>
      </Box>
      <ButtonLink onClick={() => showDocument(document.id)} color="textPrimary">
        {document.name}
      </ButtonLink>
    </StyledContainer>

    {imgUrl && (
      <Box my="1rem">
        <ExpandableImageComponent
          src={imgUrl}
          caption={document?.name}
          height="10rem"
          isSquare
        />
      </Box>
    )}
  </Box>
);

ShowDocumentComponent.defaultProps = {
  imgUrl: null,
};

ShowDocumentComponent.propTypes = {
  document: PropTypes.instanceOf(Object).isRequired,
  showDocument: PropTypes.func.isRequired,
  imgUrl: PropTypes.string,
};

export default ShowDocumentComponent;
